<template>
    <modal
        :title="title | trans"
        @close="$emit('close')">
        <template>
            <textarea readonly
                      @focus="select"
                      ref="input"
                      rows="2"
                      class="w-full p-3 rounded-lg font-mono border border-primary-300 hover:border-primary-100"
            >{{ shareUrl }}</textarea>
            <button
                    type="button"
                    ref="copyBtn"
                    class="bg-primary-300 hover:bg-primary-100 text-white py-2 px-4 rounded-lg">Copy</button>
        </template>
    </modal>
</template>

<script>
    import Modal from './Modal';
    import ClipboardJS from 'clipboard';

    export default {
        components: {
            Modal,
        },

        props: [
            'shareToken', 'questionnaire'
        ],

        methods: {
            select() {
                this.$refs.input.select();
            }
        },

        computed: {
            title() {
                return {
                    'en': 'Share my results',
                    'es': 'Comparte mis resultados',
                };
            },

            shareUrl() {
                const href = window.location.href.split('?');

                return `${href[0]}?token=${this.shareToken}&q=${this.questionnaire}&s=${this.$route.query.s}`;
            }
        },

        mounted() {
            this.clipboard = new ClipboardJS(this.$refs.copyBtn, {
                target: trigger => this.$refs.input
            });
            this.clipboard.on('success', e => {
                e.clearSelection();
                this.$refs.copyBtn.blur();
                this.$refs.copyBtn.innerHTML = 'Copied';
            });
        },

        destroyed() {
            this.clipboard.destroy();
        },
    }
</script>
